<div style="display: flex; flex-direction: column; column-gap: 10px;">
    @if (isUnsavedPreview) {
        <div>
            Save to see the Tax Authorities that use this taxable value and the tax amount.
        </div>
    } @else if (isManualUsage) {
        @for (item of items; track item) {
            <div>{{ item }}</div>
        } @empty {
            <div>No Tax Authority Line Items use this taxable value.</div>
        }
        <div></div>
    } @else if (hasConfigurationChanged) {
        <div>
            The TRA/TA configuration changed. The additional information is not available.
        </div>
    } @else {
        @for (item of items; track item) {
            <div>{{ item }}</div>
        }
        <div></div>
        @if (adjustmentAssessedValue) {
            <div>
                <span>Adjustments:</span>
                {{adjustmentAssessedValue * -1 | number}}
            </div>
        }
        @for (taxableAssessmentName of uniqueTaxableAssessmentNames; track taxableAssessmentName) {
            <div>
                <span style="font-weight: bold">Taxable Assessment:</span>
                {{ taxableAssessmentName }}
            </div>
        }
    }
    @if (!isUnsavedPreview) {
        <div>
            <span style="font-weight: bold">Total Rate-Based Taxes:</span>
            ${{ taxAmount | number: '1.2-2' }}
        </div>
    }
</div>
